export default __webpack_public_path__ + "static/medgas_valve_box_w.a969fd832ae0d815edee7fff1382b284.svg";